import {
  Framework,
  FrameworkProps,
} from "~/pages/compliance/Framework/Framework";

const FrameworkEntryPage = ({ space }: FrameworkProps) => {
  return <Framework {...{ space }} />;
};

export default FrameworkEntryPage;
